export default __webpack_public_path__ + "static/media/planet-odyssey.47173497.mp4";